import createRulesObject from '@/utils/functions/tasklist/createRulesObject'
import { PendingUpload } from 'alurkerja-ui'
import classNames from 'classnames'
import { Controller } from 'react-hook-form'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function InputMultiFileUpload({ fieldSpec, value, control, setValue }: any) {
  const rulesObject = createRulesObject(fieldSpec)

  return (
    <div>
      <label
        className={classNames('font-medium', {
          'after:content-["*"] after:text-red-400 after:text-sm': fieldSpec.constraints?.required,
        })}
        htmlFor={fieldSpec.name}
      >
        {fieldSpec.label}
      </label>
      <Controller
        name={fieldSpec.name}
        control={control}
        rules={rulesObject}
        render={({ fieldState }) => {
          return (
            <>
              <PendingUpload
                asFile
                defaultValue={value}
                multiple={true}
                onChange={e => {
                  setValue(fieldSpec.name, e)
                }}
                allowedExtension={['jpg', 'jpeg', 'png', 'pdf', 'csv', 'xlsx', 'zip']}
              />
              {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
            </>
          )
        }}
      ></Controller>
    </div>
  )
}
